class Checks {
  static isInteger (arg) {
    if (!Number.isInteger) {
      Number.isInteger = function (arg) {
        return Math.floor(arg) === arg
      }
    }

    return Number.isInteger(arg)
  }

  static isString (str) {
    return typeof str === 'string'
  }

  static isNotString (str) {
    return !this.isString(str)
  }

  static isArray (array) {
    if (!Array.isArray) {
      Array.isArray = function (arg) {
        return Object.prototype.toString.call(arg) === '[object Array]'
      }
    }

    return Array.isArray(array)
  }

  static isEmptyArray (array) {
    return this.isArray(array) && array.length === 0
  }

  static isNotEmptyArray (array) {
    return this.isArray(array) && array.length > 0
  }

  static isPlainObject (obj) {
    return Object.prototype.toString.call(obj) === '[object Object]'
  }

  static isEmptyPlainObject (obj) {
    return this.isPlainObject(obj) && Reflect.ownKeys(obj).length === 0
  }

  static isNotEmptyPlainObject (obj) {
    return this.isPlainObject(obj) && Reflect.ownKeys(obj).length > 0
  }

  static isArrayOrPlainObject (arg) {
    return this.isArray(arg) || this.isPlainObject(arg)
  }

  static isFunction (fun) {
    return Object.prototype.toString.call(fun) === '[object Function]'
  }
}

export { Checks }



// WEBPACK FOOTER //
// ./src/utils/Checks.js